import { render, staticRenderFns } from "./CaseUpdate.vue?vue&type=template&id=613b0718&scoped=true&"
import script from "./CaseUpdate.vue?vue&type=script&lang=js&"
export * from "./CaseUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CaseUpdate.vue?vue&type=style&index=0&id=613b0718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b0718",
  null
  
)

export default component.exports